import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

var items = document.querySelectorAll('.references a');
animate(items);

// filter on click
each('.filters li.btnFilter', function(el) {
    el.addEventListener('click', function(e) {
        e.preventDefault();
        filterLinks(el);
    });
});

// filter links functions
function filterLinks(element) {
    // get text
    var el = element.getAttribute('id'),
    linksTolowerCase = el.toLowerCase();
        // convert to lowercase
    // if all remove all elements
    if (el === 'all') {
        // first show all view class
        each('.view', function(e) {
            e.classList.remove('view');
        });
        // no show init animation
        animate(items);
    } else {
        // if not click all remove all elements
        each('.view', function(e) {
            e.classList.remove('view');
        });
    }
    // show animation for current elements
    animate(document.querySelectorAll('.' + linksTolowerCase));
};
// forech arrays
function each(el, callback) {
    var allDivs = document.querySelectorAll(el),
        alltoArr = Array.prototype.slice.call(allDivs);
    Array.prototype.forEach.call(alltoArr, function(selector, index) {
        if (callback) return callback(selector);
    });
};
// animate function
function animate(item) {
    (function show(counter) {
        setTimeout(function() {
            item[counter].classList.add('view');
            counter++;
            if (counter < item.length) show(counter);
        },50);
    })(0);
};
